import React, { Fragment } from "react";

import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Row, Col } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import Logo from "../../../../../assets/Logo.png";
import { reduxForm } from "redux-form";
import { object } from "yup";

const styles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: 90,
    fontWeight: 500,
    // backgroundColor: "red",
    padding: 20,
  },
  mainHeader: {
    display: "flex",
    padding: "0px 20px",
    paddingTop: "10px",
    // justifyContent: "space-between",
    flexDirection: "column",
    alignItems: "center",
    color: "black",
    marginBottom: "40px",
    // backgroundColor: "#284F68",
  },
  headerLogo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "10px",
  },
  headerTextSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    color: "black",
    fontSize: 12,
    textAlign: "center",
  },
  taxPersonsSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    color: "black",
    textAlign: "left",
  },
  headingText: {
    fontSize: "23px",
    marginBottom: "5px",
    // color: "#fff",
    display: "block",
  },
  propertyDetailsContainer: {
    display: "block",
    width: "100%",
    border: "black 1px solid",
    marginTop: 40,
  },
  footer: {
    display: "block",
    width: "100%",
    marginTop: "110px",
  },
  propertyDetailsRow: {
    border: "black 1px solid",
    paddingLeft: 5,
    paddingBottom: 0,
  },
  propertyDetailsInnerRow: {
    border: "black 1px solid",
    paddingBottom: 0,
  },
  rowTextSize: {
    fontSize: 8,
  },
  blackBackgroundWhiteText: {
    backgroundColor: "#000",
    color: "#fff",
  },
  grayBackgroundWhiteText: {
    backgroundColor: "#888",
    color: "#fff",
  },
  whiteBackgroundBlackText: {
    backgroundColor: "#fff",
    color: "#000",
  },
});

const propertyOwnersView = (property_owners) => {
  const propertyOwners = property_owners?.map((item) => ({
    ...item,
    cnic: item?.cnic?.split("-")?.join(""),
  }));
  const titleRowsHeadings = [
    "Name",
    "Father Name",
    "Phone",
    "Email",
    "CNIC",
    "Document",
  ];
  const rowPropertyOwnerKeys = [
    "name",
    "father_name",
    "phone_number",
    "email",
    "cnic",
    "documents",
  ];
  return propertyOwners?.length > 0 ? (
    <>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          <span style={{ fontWeight: "bold" }}>Owners</span>
        </Col>
      </Row>
      <Row>
        {new Array(propertyOwners?.length)?.fill(1)?.map((_, ind) => {
          return titleRowsHeadings?.map((item, index) => {
            return propertyOwners?.[ind]?.removed ? (
              <>
                <Col span={4}>
                  <div style={{ ...styles.propertyDetailsRow }}>
                    <span>
                      {propertyOwners?.[ind]?.name
                        ? propertyOwners?.[ind]?.name
                        : "None"}
                    </span>
                  </div>
                </Col>
                <Col span={20}>
                  <div style={{ ...styles.propertyDetailsRow }}>
                    <span> Removed</span>
                  </div>
                </Col>{" "}
              </>
            ) : (
              <>
                {propertyOwners?.[ind]?.[rowPropertyOwnerKeys?.[index]] ? (
                  <Col
                    style={{
                      ...styles.propertyDetailsRow,
                      ...styles.whiteBackgroundBlackText,
                    }}
                    span={12}
                  >
                    <div style={{ fontWeight: "bold" }}>{item} </div>
                  </Col>
                ) : (
                  ""
                )}
                {propertyOwners?.[ind]?.[rowPropertyOwnerKeys?.[index]] ? (
                  <Col span={12}>
                    {rowPropertyOwnerKeys?.[index] !== "documents" ? (
                      <div style={{ ...styles.propertyDetailsRow }}>
                        <span>
                          {propertyOwners?.[ind]?.[
                            rowPropertyOwnerKeys?.[index]
                          ]
                            ? propertyOwners?.[ind]?.[
                                rowPropertyOwnerKeys[index]
                              ]
                            : "None"}
                        </span>
                      </div>
                    ) : (
                      <div style={{ ...styles.propertyDetailsRow }}>
                        <span>
                          {propertyOwners?.[ind]?.[
                            rowPropertyOwnerKeys?.[index]
                          ]?.length
                            ? "Updated"
                            : "None"}
                        </span>
                      </div>
                    )}
                  </Col>
                ) : (
                  ""
                )}
              </>
            );
          });
        })}
      </Row>
    </>
  ) : (
    ""
  );
};
const propertyOccupiersView = (property_occupies) => {
  let propertyOccupiers = property_occupies?.map((item) => ({
    ...item,
    cnic: item?.cnic?.split("-")?.join(""),
    is_renter: item?.is_renter ? "Rented" : "Self",
  }));
  const titleRowsHeadings = [
    "Name",
    "Self/Rented",
    "Father Name",
    "Phone",
    "Email",
    "CNIC",
    "Business Name",
    "Document",
  ];
  const rowPropertyOwnerKeys = [
    "name",
    "is_renter",
    "father_name",
    "phone_number",
    "email",
    "cnic",
    "business_name",
    "documents",
  ];
  const occupiersLength = propertyOccupiers?.length;
  return propertyOccupiers?.length > 0 ? (
    <>
      <Row>
        <Col
          style={{
            ...styles.propertyDetailsRow,
            ...styles.blackBackgroundWhiteText,
          }}
          span={24}
        >
          <span style={{ fontWeight: "bold" }}>Occupiers</span>
        </Col>
      </Row>
      <Row>
        {new Array(occupiersLength)?.fill(1)?.map((_, ind) => {
          return titleRowsHeadings?.map((item, index) => {
            return (
              <>
                {propertyOccupiers?.[ind]?.[rowPropertyOwnerKeys?.[index]] ? (
                  <Col
                    style={{
                      ...styles.propertyDetailsRow,
                      ...styles.whiteBackgroundBlackText,
                    }}
                    span={12}
                  >
                    <div style={{ fontWeight: "bold" }}>{item} </div>
                  </Col>
                ) : (
                  ""
                )}
                {propertyOccupiers?.[ind]?.[rowPropertyOwnerKeys?.[index]] ? (
                  <Col span={12}>
                    {rowPropertyOwnerKeys?.[index] !== "documents" ? (
                      <div style={{ ...styles.propertyDetailsRow }}>
                        <span>
                          {propertyOccupiers?.[ind]?.[
                            rowPropertyOwnerKeys?.[index]
                          ]
                            ? propertyOccupiers?.[ind]?.[
                                rowPropertyOwnerKeys[index]
                              ]
                            : "None"}
                        </span>
                      </div>
                    ) : (
                      <div style={{ ...styles.propertyDetailsRow }}>
                        <span>
                          {propertyOccupiers?.[ind]?.[
                            rowPropertyOwnerKeys?.[index]
                          ]?.length
                            ? "Updated"
                            : "None"}
                        </span>
                      </div>
                    )}
                  </Col>
                ) : (
                  ""
                )}
              </>
            );
          });
        })}
      </Row>
      {/* {propertyOccupiers?.map((item, index) => (
        <Row key={index}>
          <Col
            style={{
              ...styles.propertyDetailsRow,
              ...styles.whiteBackgroundBlackText,
            }}
            span={12}
          >
            <div style={{ fontWeight: "bold" }}>{Document} </div>
          </Col>
          <Col span={6}>
            <div style={{ ...styles.propertyDetailsRow }}>
              <span>{item?.documents?.length ? "Updated" : "None"}</span>
            </div>
          </Col>
        </Row>
      ))} */}
    </>
  ) : (
    ""
  );
};
const atvDetails = (atv, propertyClassifications) => {
  if (atv) {
    if (Object?.keys(atv)?.length) {
      return (
        <>
          <Row>
            {atv?.buildings?.length || atv?.property_land_areas?.length ? (
              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.blackBackgroundWhiteText,
                }}
                span={24}
              >
                Information Regarding Calculation of ATV
              </Col>
            ) : (
              <></>
            )}

            {atv?.land_area && (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Land Area (Sq. Yards)</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {atv?.land_area}
                </Col>
              </>
            )}

            {atv?.covered_area && (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Covered Area (Sq. Feet)</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {atv?.covered_area}
                </Col>
              </>
            )}
            {atv?.type_of_structure?.name?.length > 0 && (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Type of structure</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {atv?.type_of_structure?.name}
                </Col>
              </>
            )}
            {atv?.number_of_stories && (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Number of Stories</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {atv?.number_of_stories}
                </Col>
              </>
            )}
            {atv?.number_of_rooms && (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>
                    No. of rooms (excluding kitchen, bathroom and servant
                    quarters)
                  </b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {atv?.number_of_rooms}
                </Col>
              </>
            )}

            {atv?.dc_rate ? (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>DC Rate</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {`Rs ${atv?.dc_rate?.toLocaleString()}`}
                </Col>
              </>
            ) : (
              <></>
            )}

            {atv?.structure_rate ? (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Structure Rate</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {`Rs ${atv?.structure_rate?.toLocaleString()}`}
                </Col>
              </>
            ) : (
              <></>
            )}
            {atv?.annual_tax ? (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Annual Tax</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {`Rs ${atv?.annual_tax?.toLocaleString()}`}
                </Col>
              </>
            ) : (
              <></>
            )}
            {atv?.annual_taxable_value ? (
              <>
                <Col style={{ ...styles.propertyDetailsRow }} span={6}>
                  <b>Annual Taxable Value</b>
                </Col>
                <Col style={{ ...styles.propertyDetailsRow }} span={18}>
                  {`Rs ${atv?.annual_taxable_value?.toLocaleString()}`}
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
          {atv?.diffObjMobile?.property_land_areas?.length && (
            <Row>
              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.grayBackgroundWhiteText,
                }}
                span={24}
              >
                Land Area
              </Col>

              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.grayBackgroundWhiteText,
                }}
                span={8}
              >
                Action
              </Col>
              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.grayBackgroundWhiteText,
                }}
                span={8}
              >
                Classification
              </Col>
              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.grayBackgroundWhiteText,
                }}
                span={8}
              >
                Area (Marlas)
              </Col>
              {atv?.diffObjMobile?.property_land_areas.map((element, index) => {
                if (!Array.isArray(element)) {
                  return (
                    <>
                      <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                        (
                        <b>
                          {atv?.diffObjMobile?.property_land_areas?.[
                            index
                          ]?.action
                            .charAt(0)
                            .toUpperCase() +
                            atv?.diffObjMobile?.property_land_areas?.[
                              index
                            ]?.action.slice(1) || ""}
                        </b>
                        )
                      </Col>
                      <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                        {element?.newVal?.valuation_classification_id ? (
                          propertyClassifications.map(
                            (nestedElement, nestedIndex) => {
                              if (
                                element?.newVal?.valuation_classification_id ===
                                nestedElement?.id
                              ) {
                                return <b>{nestedElement.name}</b>;
                              }
                            }
                          )
                        ) : element?.area?.parentObj?.valuation_classification
                            ?.name ? (
                          <b>
                            {
                              element?.area?.parentObj?.valuation_classification
                                ?.name
                            }
                          </b>
                        ) : element?.oldVal?.valuation_classification?.name ? (
                          <b>
                            {element?.oldVal?.valuation_classification?.name}
                          </b>
                        ) : (
                          <b>Unchanged</b>
                        )}
                      </Col>
                      <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                        <b>
                          {element?.newVal?.area
                            ? element?.newVal?.area
                            : element.area?.newVal
                            ? element.area?.newVal
                            : element?.oldVal?.area
                            ? element?.oldVal?.area
                            : ""}
                        </b>
                      </Col>
                    </>
                  );
                }
              })}
            </Row>
          )}
          {atv?.diffObjMobile?.buildings?.length && (
            <Row>
              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.grayBackgroundWhiteText,
                }}
                span={24}
              >
                Covered Area
              </Col>

              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.grayBackgroundWhiteText,
                }}
                span={4}
              >
                Building #
              </Col>
              <Col style={{ ...styles.propertyDetailsRow }} span={20}></Col>
              {atv?.diffObjMobile?.buildings.map((element, index) => {
                if (element !== null && !Array.isArray(element)) {
                  return (
                    <>
                      <Col style={{ ...styles.propertyDetailsRow }} span={4}>
                        {element?.action === "added" ? (
                          <b>(New)</b>
                        ) : (
                          <b>{Number(element.index) + 1}</b>
                        )}
                      </Col>
                      <Col
                        style={{ ...styles.propertyDetailsInnerRow }}
                        span={20}
                      >
                        <Row>
                          {element?.action !== undefined && (
                            <Col
                              style={{ ...styles.propertyDetailsInnerRow }}
                              span={24}
                            >
                              <b>
                                {`(${
                                  element.action.charAt(0).toUpperCase() +
                                  element.action.slice(1)
                                })`}
                              </b>
                            </Col>
                          )}
                          {element?.newVal !== undefined &&
                            Object.keys(element?.newVal).length > 0 && (
                              <Col
                                style={{ ...styles.propertyDetailsInnerRow }}
                                span={24}
                              >
                                <Row>
                                  <Col
                                    style={{
                                      ...styles.propertyDetailsInnerRow,
                                      ...styles.grayBackgroundWhiteText,
                                    }}
                                    span={4}
                                  >
                                    Floor #
                                  </Col>
                                  <Col
                                    style={{
                                      ...styles.propertyDetailsInnerRow,
                                    }}
                                    span={20}
                                  ></Col>
                                  {element?.newVal?.data?.map(
                                    (element, index) => {
                                      if (
                                        element !== null &&
                                        !Array.isArray(element)
                                      ) {
                                        return (
                                          <>
                                            <Col
                                              style={{
                                                ...styles.propertyDetailsInnerRow,
                                              }}
                                              span={4}
                                            >
                                              {element?.action === "added" ? (
                                                <b>(New)</b>
                                              ) : element?.index !==
                                                undefined ? (
                                                <b>
                                                  {Number(element.index) + 1}
                                                </b>
                                              ) : (
                                                <b>(New)</b>
                                              )}
                                            </Col>
                                            <Col
                                              style={{
                                                ...styles.propertyDetailsInnerRow,
                                              }}
                                              span={20}
                                            >
                                              {element.action !== undefined && (
                                                <Col
                                                  style={{
                                                    ...styles.propertyDetailsInnerRow,
                                                  }}
                                                  span={24}
                                                >
                                                  <b>
                                                    {`(${
                                                      element.action
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      element.action.slice(1)
                                                    })`}
                                                  </b>
                                                </Col>
                                              )}
                                              {element?.action !==
                                                "deleted" && (
                                                <>
                                                  <Row>
                                                    <Col
                                                      style={{
                                                        ...styles.propertyDetailsInnerRow,
                                                        ...styles.grayBackgroundWhiteText,
                                                      }}
                                                      span={8}
                                                    >
                                                      RCC
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        ...styles.propertyDetailsInnerRow,
                                                        ...styles.grayBackgroundWhiteText,
                                                      }}
                                                      span={8}
                                                    >
                                                      Non-RCC
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        ...styles.propertyDetailsInnerRow,
                                                        ...styles.grayBackgroundWhiteText,
                                                      }}
                                                      span={8}
                                                    >
                                                      Classification
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col
                                                      style={{
                                                        ...styles.propertyDetailsInnerRow,
                                                      }}
                                                      span={8}
                                                    >
                                                      <b>
                                                        {element?.rcc_area
                                                          ?.newVal
                                                          ? element?.rcc_area
                                                              ?.newVal
                                                          : element?.newVal
                                                              ?.rcc_area
                                                          ? element?.newVal
                                                              ?.rcc_area
                                                          : element?.rcc_area
                                                          ? element?.rcc_area
                                                          : "unchanged"}
                                                      </b>
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        ...styles.propertyDetailsInnerRow,
                                                      }}
                                                      span={8}
                                                    >
                                                      <b>
                                                        {element?.non_rcc_area
                                                          ?.newVal
                                                          ? element
                                                              ?.non_rcc_area
                                                              ?.newVal
                                                          : element?.newVal
                                                              ?.non_rcc_area
                                                          ? element?.newVal
                                                              ?.non_rcc_area
                                                          : element?.non_rcc_area
                                                          ? element?.non_rcc_area
                                                          : "unchanged"}
                                                      </b>
                                                    </Col>
                                                    <Col
                                                      style={{
                                                        ...styles.propertyDetailsInnerRow,
                                                      }}
                                                      span={8}
                                                    >
                                                      {propertyClassifications.map(
                                                        (
                                                          nestedElement,
                                                          nestedIndex
                                                        ) => {
                                                          if (
                                                            element
                                                              ?.valuation_classification_id
                                                              ?.newVal
                                                          ) {
                                                            if (
                                                              element
                                                                ?.valuation_classification_id
                                                                ?.newVal ===
                                                              nestedElement?.id
                                                            ) {
                                                              return (
                                                                <b>
                                                                  {
                                                                    nestedElement.name
                                                                  }
                                                                </b>
                                                              );
                                                            }
                                                          } else if (
                                                            element?.newVal
                                                              ?.valuation_classification_id
                                                          ) {
                                                            if (
                                                              element?.newVal
                                                                ?.valuation_classification_id ===
                                                              nestedElement?.id
                                                            ) {
                                                              return (
                                                                <b>
                                                                  {
                                                                    nestedElement.name
                                                                  }
                                                                </b>
                                                              );
                                                            }
                                                          } else if (
                                                            element?.valuation_classification_id
                                                          ) {
                                                            if (
                                                              element?.valuation_classification_id ===
                                                              nestedElement?.id
                                                            ) {
                                                              return (
                                                                <b>
                                                                  {
                                                                    nestedElement.name
                                                                  }
                                                                </b>
                                                              );
                                                            }
                                                          } else {
                                                            if (
                                                              nestedIndex === 0
                                                            ) {
                                                              return (
                                                                <b>unchanged</b>
                                                              );
                                                            }
                                                          }
                                                        }
                                                      )}
                                                    </Col>
                                                  </Row>
                                                </>
                                              )}
                                            </Col>
                                          </>
                                        );
                                      }
                                    }
                                  )}
                                </Row>
                              </Col>
                            )}
                          {element?.data !== undefined &&
                            element?.data.length > 0 && (
                              <Col
                                style={{ ...styles.propertyDetailsInnerRow }}
                                span={24}
                              >
                                <Row>
                                  <Col
                                    style={{
                                      ...styles.propertyDetailsInnerRow,
                                      ...styles.grayBackgroundWhiteText,
                                    }}
                                    span={4}
                                  >
                                    Floor #
                                  </Col>
                                  <Col
                                    style={{
                                      ...styles.propertyDetailsInnerRow,
                                    }}
                                    span={20}
                                  ></Col>
                                  {element?.data.map((element, index) => {
                                    if (
                                      element !== null &&
                                      !Array.isArray(element)
                                    ) {
                                      return (
                                        <>
                                          <Col
                                            style={{
                                              ...styles.propertyDetailsInnerRow,
                                            }}
                                            span={4}
                                          >
                                            {element?.action === "added" ? (
                                              <b>(New)</b>
                                            ) : element?.index !== undefined ? (
                                              <b>{Number(element.index) + 1}</b>
                                            ) : (
                                              <b></b>
                                            )}
                                          </Col>
                                          <Col
                                            style={{
                                              ...styles.propertyDetailsInnerRow,
                                            }}
                                            span={20}
                                          >
                                            {element.action !== undefined && (
                                              <Col
                                                style={{
                                                  ...styles.propertyDetailsInnerRow,
                                                }}
                                                span={24}
                                              >
                                                <b>
                                                  {`(${
                                                    element.action
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    element.action.slice(1)
                                                  })`}
                                                </b>
                                              </Col>
                                            )}
                                            {element?.action !== "deleted" && (
                                              <>
                                                <Row>
                                                  <Col
                                                    style={{
                                                      ...styles.propertyDetailsInnerRow,
                                                      ...styles.grayBackgroundWhiteText,
                                                    }}
                                                    span={8}
                                                  >
                                                    RCC
                                                  </Col>
                                                  <Col
                                                    style={{
                                                      ...styles.propertyDetailsInnerRow,
                                                      ...styles.grayBackgroundWhiteText,
                                                    }}
                                                    span={8}
                                                  >
                                                    Non-RCC
                                                  </Col>
                                                  <Col
                                                    style={{
                                                      ...styles.propertyDetailsInnerRow,
                                                      ...styles.grayBackgroundWhiteText,
                                                    }}
                                                    span={8}
                                                  >
                                                    Classification
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col
                                                    style={{
                                                      ...styles.propertyDetailsInnerRow,
                                                    }}
                                                    span={8}
                                                  >
                                                    <b>
                                                      {element?.rcc_area?.newVal
                                                        ? element?.rcc_area
                                                            ?.newVal
                                                        : element?.newVal
                                                            ?.rcc_area
                                                        ? element?.newVal
                                                            ?.rcc_area
                                                        : element?.rcc_area
                                                        ? element?.rcc_area
                                                        : "unchanged"}
                                                    </b>
                                                  </Col>
                                                  <Col
                                                    style={{
                                                      ...styles.propertyDetailsInnerRow,
                                                    }}
                                                    span={8}
                                                  >
                                                    <b>
                                                      {element?.non_rcc_area
                                                        ?.newVal
                                                        ? element?.non_rcc_area
                                                            ?.newVal
                                                        : element?.newVal
                                                            ?.non_rcc_area
                                                        ? element?.newVal
                                                            ?.non_rcc_area
                                                        : element?.non_rcc_area
                                                        ? element?.non_rcc_area
                                                        : "unchanged"}
                                                    </b>
                                                  </Col>
                                                  <Col
                                                    style={{
                                                      ...styles.propertyDetailsInnerRow,
                                                    }}
                                                    span={8}
                                                  >
                                                    {propertyClassifications.map(
                                                      (
                                                        nestedElement,
                                                        nestedIndex
                                                      ) => {
                                                        if (
                                                          element
                                                            ?.valuation_classification_id
                                                            ?.newVal
                                                        ) {
                                                          if (
                                                            element
                                                              ?.valuation_classification_id
                                                              ?.newVal ===
                                                            nestedElement?.id
                                                          ) {
                                                            return (
                                                              <b>
                                                                {
                                                                  nestedElement.name
                                                                }
                                                              </b>
                                                            );
                                                          }
                                                        } else if (
                                                          element?.newVal
                                                            ?.valuation_classification_id
                                                        ) {
                                                          if (
                                                            element?.newVal
                                                              ?.valuation_classification_id ===
                                                            nestedElement?.id
                                                          ) {
                                                            return (
                                                              <b>
                                                                {
                                                                  nestedElement.name
                                                                }
                                                              </b>
                                                            );
                                                          }
                                                        } else if (
                                                          element?.valuation_classification_id
                                                        ) {
                                                          if (
                                                            element?.valuation_classification_id ===
                                                            nestedElement?.id
                                                          ) {
                                                            return (
                                                              <b>
                                                                {
                                                                  nestedElement.name
                                                                }
                                                              </b>
                                                            );
                                                          }
                                                        } else {
                                                          if (
                                                            nestedIndex === 0
                                                          ) {
                                                            return (
                                                              <b>unchanged</b>
                                                            );
                                                          }
                                                        }
                                                      }
                                                    )}
                                                  </Col>
                                                </Row>
                                              </>
                                            )}
                                          </Col>
                                        </>
                                      );
                                    }
                                  })}
                                </Row>
                              </Col>
                            )}
                        </Row>
                      </Col>
                    </>
                  );
                }
              })}
            </Row>
          )}
        </>
      );
    }
  }
};
const documentsView = (data) => {
  if (data?.length) {
    return (
      <>
        <Row>
          <Col
            style={{
              ...styles.propertyDetailsRow,
              ...styles.blackBackgroundWhiteText,
            }}
            span={24}
          >
            Further Information
          </Col>
          <Col style={{ ...styles.propertyDetailsRow }} span={6}>
            <b>Documents</b>
          </Col>
          <Col style={{ ...styles.propertyDetailsRow }} span={18}>
            Added
          </Col>
        </Row>
      </>
    );
  }
};
const propertyDetailView = (data) => {
  const { change_requests, propertyClassifications } = data;
  const { property_owners, occupiers, changed_data, documents } =
    change_requests[change_requests?.length - 1];
  return (
    <>
      <View style={{ ...styles.headerTextSection }}>
        <Row>
          <Col>
            <span style={{ fontWeight: "bold", fontSize: "14px" }}>
              Changes
            </span>
          </Col>
        </Row>
      </View>
      <View style={{ ...styles.propertyDetailsContainer }}>
        <Row>
          {
            //if there is only one object in changed_data and it is 'atv', then don't render the heading 'basic details' as atv is not displayed under basic details
            (Object.keys(
              change_requests[change_requests?.length - 1]?.changed_data
            ).length > 1 ||
              (Object.keys(
                change_requests[change_requests?.length - 1]?.changed_data
              ).length === 1 &&
                !change_requests[change_requests?.length - 1]?.changed_data
                  .atv)) && (
              <Col
                style={{
                  ...styles.propertyDetailsRow,
                  ...styles.blackBackgroundWhiteText,
                }}
                span={24}
              >
                Basic Details
              </Col>
            )
          }
          <Col span={24}>
            {Object.keys(
              change_requests[change_requests?.length - 1]?.changed_data
            ).map((element, index) => {
              if (
                element !== "atv" &&
                element !== "khasra_number_id" &&
                element !== "mouza_id"
              ) {
                return (
                  <Row key={index}>
                    <Col style={{ ...styles.propertyDetailsRow }} span={8}>
                      {element === "highway_kms" ? (
                        <span>KMs</span>
                      ) : (
                        <span style={{ fontWeight: "bold" }}>
                          {element.charAt(0).toUpperCase() +
                            element.slice(1).toString().split("_").join(" ")}
                        </span>
                      )}
                    </Col>
                    <Col style={{ ...styles.propertyDetailsRow }} span={16}>
                      {
                        change_requests[change_requests.length - 1]
                          ?.changed_data[element]
                      }
                    </Col>
                  </Row>
                );
              }
            })}
            {propertyOwnersView(property_owners)}
            {propertyOccupiersView(occupiers)}
            {atvDetails(changed_data?.atv, propertyClassifications)}
            {documentsView(documents)}
          </Col>
        </Row>
      </View>
    </>
  );
};
const footer = (data) => {
  return (
    <View style={{ ...styles.footer }}>
      <Row>
        <Col span={4}></Col>
        <Col span={5}>Assessing Authority </Col>
        <Col span={8}></Col>
        <Col span={5}>Seal of</Col>
      </Row>
      <Row>
        <Col span={4}></Col>
        <Col span={5}>Highway/Motorways</Col>
        <Col span={7}></Col>
        <Col span={5}>Assessing Authority</Col>
      </Row>
      <Row>
        <Col span={16}></Col>
        <Col span={8} style={{ marginBottom: 30 }}>
          Date:{" "}
          <span style={{ fontWeight: "bold" }}>
            {moment().format("DD-MM-YYYY")}
          </span>
        </Col>
      </Row>
    </View>
  );
};

const Ph9FormPdf = ({ data }) => (
  <Document>
    <Page pageNumber={1} wrap>
      <View style={{ ...styles.page }}>
        <View style={styles.mainHeader}>
          <View style={{ ...styles.headerLogo }}>
            <img src={Logo}></img>
          </View>
          <View style={{ ...styles.headerTextSection, ...styles.rowTextSize }}>
            <Text style={{ fontSize: 16, fontWeight: "bold" }}>
              <p>
                Punjab Tax on Properties other than Agricultural Land abutting
                to National/Provincial Highways and within the area of Motorways
                outside the Rating Areas Rules,
                {moment(data?.taxes?.[0]?.year).format("YYYY")}
              </p>
            </Text>
            <Text></Text>
            <Text style={{ fontSize: 16, fontWeight: "bold" }}>
              <p>FORM PH-9</p>
            </Text>
          </View>
        </View>
        <View
          style={{
            width: "100%",
            marginBottom: "40px",
          }}
        >
          <Row style={{ marginBottom: "15px" }}>
            <Col span={6}>
              <Text>
                Serial NO :{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.ph9s?.[0]?.serial_number}
                </span>
              </Text>
            </Col>
            <Col span={8}></Col>
            <Col span={6}>
              <Text>Office of Assessing Authority:</Text>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <Text>
                To:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.property_owners.length > 1 ? (
                    <>
                      {data?.property_owners[0]?.name +
                        " , " +
                        data?.property_owners[1]?.name}
                    </>
                  ) : (
                    <>{data?.property_owners[0]?.name}</>
                  )}
                </span>
              </Text>
            </Col>
            <Col span={4}></Col>
            <Col span={6}>
              <Text>
                District:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.district?.name}
                </span>
              </Text>
            </Col>
          </Row>
        </View>
        <View style={{ width: "100%", marginBottom: "40px" }}>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={8}>
              <Text>
                Name:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.property_owners.length > 1 ? (
                    <>
                      {data?.property_owners[0]?.name +
                        " , " +
                        data?.property_owners[1]?.name}
                    </>
                  ) : (
                    <>{data?.property_owners[0]?.name}</>
                  )}
                </span>
              </Text>
            </Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Text>
                Circle:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.circle?.name || ""}
                </span>
              </Text>
            </Col>
          </Row>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={8}>
              <Text>
                Address :{" "}
                <span style={{ fontWeight: "bold" }}>{data?.address}</span>
              </Text>
            </Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Text>
                Zone:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.zone?.name || ""}
                </span>
              </Text>
            </Col>
          </Row>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={8}>
              <Text>
                Name of Highway/Motorway:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.highway?.name || ""}
                </span>
              </Text>
            </Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Text>
                No. of Property in Property Register:{" "}
                <span style={{ fontWeight: "bold" }}>{data?.id || ""}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Text>
                Type of Property:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {data?.property_type?.name || ""}
                </span>
              </Text>
            </Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Text>
                PIN:{" "}
                <span style={{ fontWeight: "bold" }}>{data?.pin || ""}</span>
              </Text>
            </Col>
          </Row>
        </View>
        <View
          style={{
            marginBottom: "30px",
            fontWeight: 500,
          }}
        >
          <Row>
            <Col span={1}> 1)</Col>
            <Col span={23}>
              <Text>
                In view of the information received by me with regard to the
                under mentioned property owned / occupied by you, it is
                necessary to amend the valuation list for the reasons and in the
                manner indicated below so far as it relates to this property.
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={1}> 2)</Col>
            <Col span={23}>
              <Text>
                You are hereby required to file objections, if any, to the
                proposed amendment within 14-days of the service of this notice.
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={1}> 3)</Col>
            <Col span={23}>
              <Text>
                In case you fail to file an objection within the period
                specified above, the proposed amendment will be given effect to
                and will be binding on all concerned.
              </Text>
            </Col>
          </Row>
        </View>
        {propertyDetailView(data)}
        {footer(data)}
      </View>
    </Page>
  </Document>
);

const mapStateToProps = ({ property: { currentProperty } }) => ({
  currentProperty,
});

const mapDispatchToProps = (dispatch) => ({});

Ph9FormPdf.propTypes = {
  currentProperty: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(Ph9FormPdf);
